import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type ChargebeeSubscription = {
    subscriptionId: string
    id?: string
    customerId?: string
    planId?: string
    status?: string
    createdAt?: string
    currentTermStart?: string
    currentTermEnd?: string
    customer?: {
        id?: string
        email?: string
        company?: string
        phone?: string
    }
}

export const getChargebeeSubscriptions = (): Promise<ChargebeeSubscription[]> => {
    return api.get('/v2/chargebee/subscriptions')
}

export const getChargebeeSubscriptionsQueryOptions = () => {
    return queryOptions({
        queryKey: ['chargebee', 'subscriptions'],
        queryFn: () => getChargebeeSubscriptions(),
    })
}

type UseChargebeeSubscriptionsOptions = {
    queryConfig?: QueryConfig<typeof getChargebeeSubscriptions>
}

export const useChargebeeSubscriptions = ({ queryConfig }: UseChargebeeSubscriptionsOptions = {}) => {
    return useQuery({
        ...getChargebeeSubscriptionsQueryOptions(),
        ...queryConfig,
    })
}


